(() => {

  $(document).ready(() => {
    const marketId = $('#MarketId').val();
    const $contactsPage = $('.contacts-page');
    const headerHeight = $('#header').height();

    if ($contactsPage.length && marketId) {
      setTimeout(() => {
        const $header = $('#header');
        $('.accordion__item').each((index, item) => {
          if (item.dataset.name && item.dataset.name == marketId) {
            const $link = $(item).find('> a');
              $([document.documentElement, document.body]).animate({
                  scrollTop: $link.offset().top - $header.innerHeight() - headerHeight
            }, 250);
            $link.trigger('click');
          }
        });
    
      }, 1500)
      
    }
  })
    
})();